var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "SvgjsSvg1000",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 25,
  height: 25,
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "SvgjsDefs1001"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "SvgjsPath1007",
  d: "M725.53984 105.53984C726.51615 104.56353 728.09906 104.56353 729.07537 105.53984L747.46015 123.92462C748.43646 124.90093 748.43646 126.48384 747.46015 127.46015L747.46015 127.46015C746.48384 128.43646 744.90093 128.43646 743.92462 127.46015L725.53984 109.07536999999999C724.56353 108.09906 724.56353 106.51615 725.53984 105.53984Z ",
  fill: "#ffffff",
  fillOpacity: 1,
  transform: "matrix(1,0,0,1,-724,-104)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "SvgjsPath1008",
  d: "M725.53984 127.46016C724.56353 126.48385 724.56353 124.90094 725.53984 123.92463000000001L743.92462 105.53985C744.90093 104.56354 746.48384 104.56354 747.46015 105.53985L747.46015 105.53985C748.43646 106.51616 748.43646 108.09907 747.46015 109.07538L729.07537 127.46016C728.09906 128.43647 726.51615 128.43647 725.53984 127.46016Z ",
  fill: "#ffffff",
  fillOpacity: 1,
  transform: "matrix(1,0,0,1,-724,-104)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-icon.7f0a7f3322be3a51624eebbfeca59778.svg";